import { Box, Divider, Text } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../../../../ricos-context/index.js";
import { PREDEFINED_SWATCH_COLORS } from "./../../../../../plugin-button/defaults.js";
import { removeColorDuplicates } from "./../../../../color-picker/new-color-picker/components/swatch-color-picker/utils.js";
import { CUSTOM_SWATCHES, THEME_SWATCHES } from "../../data-hooks.js";
import { NewColorSwatches } from "../new-color-swatches/new-color-swatches.js";
import classes from "./swatch-color-picker-scss.js";
const THEME_COLORS_GRID_ID = "theme-colors-grid";
const CUSTOM_COLORS_GRID_ID = "custom-colors-grid";
const SwatchColorPicker = ({
  currentColor,
  themeColors: themeColorsProp,
  customColors: customColorsProp,
  onAddClick,
  onColorSelected,
  onColorPreviewStart,
  onColorPreviewEnd,
  setAddButtonRef
}) => {
  const { t } = useContext(RicosContext);
  const { themeColors, customColors } = removeColorDuplicates(themeColorsProp, customColorsProp);
  return /* @__PURE__ */ React.createElement("div", { className: classes.content }, themeColors.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { direction: "vertical", padding: "SP3", gap: "SP3" }, /* @__PURE__ */ React.createElement(Text, { size: "small", weight: "bold", id: THEME_COLORS_GRID_ID }, t("Color_Picker_ThemeColor_Title")), /* @__PURE__ */ React.createElement(
    NewColorSwatches,
    {
      colors: themeColors,
      selectedColor: currentColor?.toUpperCase(),
      onColorSelected,
      onColorPreviewStart,
      onColorPreviewEnd,
      dataHook: THEME_SWATCHES,
      labelledById: THEME_COLORS_GRID_ID
    }
  )), /* @__PURE__ */ React.createElement(Divider, null)), /* @__PURE__ */ React.createElement(Box, { direction: "vertical", padding: "SP3", gap: "SP3" }, /* @__PURE__ */ React.createElement(Text, { size: "small", weight: "bold", id: CUSTOM_COLORS_GRID_ID }, t("Color_Picker_CustomColor_Title")), /* @__PURE__ */ React.createElement(
    NewColorSwatches,
    {
      colors: [...PREDEFINED_SWATCH_COLORS, ...customColors],
      onAddClick,
      setAddButtonRef,
      selectedColor: currentColor?.toUpperCase(),
      onColorSelected,
      onColorPreviewStart,
      onColorPreviewEnd,
      dataHook: CUSTOM_SWATCHES,
      labelledById: CUSTOM_COLORS_GRID_ID
    }
  )));
};
export {
  SwatchColorPicker
};
//# sourceMappingURL=swatch-color-picker.js.map
